import { format, parseISO } from "date-fns";

import { WaitlistEntry } from "@/types/waitlist";

export function formatWaitlistDateRange(
  entry: Pick<WaitlistEntry, "startDate" | "endDate">,
): string {
  const start = format(parseISO(entry.startDate), "MMM d, yyyy");
  if (entry.startDate === entry.endDate) return start;
  return `${start} – ${format(parseISO(entry.endDate), "MMM d, yyyy")} (inclusive)`;
}
